// extracted by mini-css-extract-plugin
export default {"container":"main_container__k8twq","content":"main_content__5Hu9Y"};